import { render, staticRenderFns } from "./BtnDetalharItemContrato.vue?vue&type=template&id=6a890794&"
import script from "./BtnDetalharItemContrato.vue?vue&type=script&lang=js&"
export * from "./BtnDetalharItemContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports